module.exports = __webpack_public_path__ + "static/media/new-york-20.6ef13c32.jpg";